import { BaseService } from '@/core/base-service';

export default class YouTrackUserSettingService extends BaseService<any> {
	public constructor() {
		super('services/serviceyoutrack/api/user-setting');
	}
}
